import s from './TextCell.module.scss';
import { useRef } from 'react';
import { Tooltip } from '@/shared/ui/Tooltip/Tooltip';
import { useIsOverflow } from '@/shared/lib/hooks/useIsOverflow';

interface TextCellProps {
  value: string | number | null | undefined;
  emptyValue?: string;
}

export const TextCell = (props: TextCellProps) => {
  const { value, emptyValue = '—' } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { isOverflowW } = useIsOverflow(wrapperRef);

  const displayValue = value === null || value === undefined || value === '' ? emptyValue : String(value);

  return (
    <Tooltip value={displayValue} isOverflow={isOverflowW}>
      <div className={s.TextCell}>
        <div className={s.wrapper} ref={wrapperRef}>
          <span className={s.value}>{displayValue}</span>
        </div>
      </div>
    </Tooltip>
  );
};
